"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Cut = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Cut_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38 8.517c.488.844 1.558 1.124 2.528 1.222a3.38 3.38 0 0 1 2.595 1.674l.533.922a2.418 2.418 0 0 1-.886 3.305l-.062.035a2.423 2.423 0 0 1-3.308-.886l-1.972-3.412-.002-.004-.807-1.396-.807 1.396a.526.526 0 0 1-.021.034L5.216 14.79a2.423 2.423 0 0 1-3.308.887l-.062-.036a2.418 2.418 0 0 1-.885-3.305l.533-.922a3.38 3.38 0 0 1 2.595-1.674c.97-.097 2.042-.378 2.53-1.222l.268-.465-3.522-6.094A1.357 1.357 0 0 1 3.862.104l.06-.034a.5.5 0 0 1 .682.183L8 6.127 11.394.253a.5.5 0 0 1 .683-.183l.059.034c.65.375.872 1.205.497 1.854L9.11 8.052l.269.465Zm.808 3.25 1.458 2.523c.393.679 1.262.912 1.942.52l.062-.036a1.42 1.42 0 0 0 .52-1.94l-.534-.922a2.383 2.383 0 0 0-3.253-.871.531.531 0 0 0-.194.726Zm-4.575-.726a2.383 2.383 0 0 0-3.253.871l-.533.922a1.42 1.42 0 0 0 .52 1.94l.062.036c.68.392 1.548.159 1.94-.52l1.459-2.523a.531.531 0 0 0-.195-.726Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Cut_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Cut;
exports["default"] = _default;